









































































import i18n from 'vue-i18n';
import axios from 'axios';
import { get, uniq, pick } from 'lodash';
import CoIcon from '../../../../Atoms/co-icon/CoIcon.vue';
import CoCardEvent from '../../../../Molecules/co-card-event/CoCardEvent.vue';
import { Event, User, Space, Image } from '@/types/GlobalTypes';
import CoButton from '../../../../Atoms/co-button/CoButton.vue';
import CoRoundButton from '../../../../Atoms/co-round-button/CoRoundButton.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoEvent from '@/components/Molecules/co-event/CoEvent.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoScrollMarker from '@/components/Molecules/co-scroll-marker/CoScrollMarker.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';

export default {
    i18n: {
        messages: {
            en: {
                endofeventlistreached: 'All events loaded',
                eventsemptyheadline: 'Community Events',
                eventsemptysubline: 'Create events on your community platform.',
                eventsemptycta: 'Create an event',
            },
            de: {
                endofeventlistreached: 'Alle Veranstaltungen geladen',
                eventsemptyheadline: 'Community-Veranstaltungen',
                eventsemptysubline:
                    'Erstelle Veranstaltungen, um Wissen auszutauschen und gemeinsame Erfahrungen zu teilen.',
                eventsemptycta: 'Erstelle eine Veranstaltung',
            },
        },
    },
    name: 'ListEvents',
    components: {
        CoCardEvent,
        CoButton,
        CoIcon,
        CoRoundButton,
        CoCard,
        CoHeadline,
        CoEvent,
        CoThumbnail,
        CoText,
        CoScrollMarker,
        CoLink,
    },
    props: {
        variant: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'micro', 'list', 'full'].includes(value),
        },
    },
    data() {
        return {
            feed: [],
            feedNextPage: null,
            loading: true,
            thisSpaceID: get(this.$store, 'state.space.ID', ''),
            userIDsToFetch: [],
            userProfiles: {},
        };
    },
    computed: {
        me() {
            return this.$store?.state.me || {};
        },
        isDesktop() {
            return window.innerWidth >= 768;
        },
        isAdmin() {
            if (
                this.$store?.state?.me?.Permissions &&
                this.$store.state.me.Permissions.includes('space_admin') === true
            ) {
                return true;
            }
            return false;
        },
        isUserAllowedToCreateEvent() {
            return this.isAdmin || !this.$store?.state?.permissions?.EventsCreateAdminsOnly;
        },
        isUserLogggedIn() {
            return this.me.ID ? true : false;
        },
    },
    async mounted() {
        this.loading = true;
        // fetch events
        await this.getEvents();
    },
    methods: {
        getEvents() {
            this.loading = true;
            return axios
                .post('/event/list/circles/v2', {
                    From: Math.round(Date.now() / 1000),
                    To: Math.round(Date.now() / 1000) * 2,
                    Limit: 10,
                    Params: this.feedNextPage || null,
                })
                .then(async (response) => {
                    const events = response.data?.Objects || null;
                    this.feedNextPage = response.data?.NextParams;

                    if (events?.length < 1) return;

                    this.userIDsToFetch = events
                        .map((e) => {
                            return (e.object?.Organizers || []).concat(e.object?.Participants || []);
                        })
                        .flat()
                        .filter((value, index, array) => array.indexOf(value) === index); // remove duplicates
                    //fetch user profiles by IDs
                    await this.fetchUserProfilesByIDs(this.userIDsToFetch);
                    //map user profiles to events and add to feed
                    let feedPage = [];
                    events.forEach((e) => {
                        if (!e.object || typeof e.object !== 'object') return;

                        let participants = e.object.Participants || [];
                        let organizers = e.object.Organizers || [];

                        let participantsProfiles = [];
                        participants.map((id) => {
                            if (this.userProfiles[id]) {
                                participantsProfiles.push(this.userProfiles[id]);
                            }
                        });

                        let organizersProfiles = [];
                        organizers.map((id) => {
                            if (this.userProfiles[id]) {
                                organizersProfiles.push(this.userProfiles[id]);
                            }
                        });

                        // add organizers to participants list and map user profiles
                        e.object.Organizers = uniq(organizersProfiles);
                        // aggregate participants and organizers profiles as one participants list
                        e.object.Participants = uniq(participantsProfiles);
                        //add item to the feedPage
                        feedPage.push({
                            ...e,
                            Space: e.space || {},
                            object: this.mapEventStucture(e),
                        });
                    });
                    //update the feed list
                    this.feed = this.feed.concat(feedPage);
                })
                .catch((error) => {
                    this.feedNextPage = null;
                    // todo show error
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchUserProfilesByIDs(userIds: string[]) {
            // fetch user profile data for a list of user IDs
            return new Promise((resolve, reject) => {
                let ids = [];
                userIds.map((id) => {
                    if (!this.userProfiles[id]) {
                        ids.push({ ID: id });
                    }
                });

                if (ids.length < 1) {
                    resolve([]);
                    return;
                }
                axios({
                    method: 'POST',
                    url: '/user/listbyids',
                    data: { IDS: ids },
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        response.data?.Users?.forEach((user) => {
                            this.userProfiles[user.ID] = {
                                ...user,
                                ...(user.Profile || {}),
                            };
                        });
                        resolve(true);
                    })
                    .catch((error) => {
                        console.log(error);
                        resolve(true);
                    });
            });
        },
        mapEventStucture(object: any) {
            const event = object.object;
            const spaceItem = object.Space;

            const e: Event = {
                ...event,
                Images: event.ImageURL ? [{ ImageURL: event.ImageURL }] : null,
                Attend: event.Participants?.includes(this.me.ID),
            };

            if (spaceItem) {
                e.Space = {
                    ID: spaceItem.ID,
                    Name: spaceItem.Name,
                    FaviconURL: spaceItem.FaviconURL,
                    PrimaryColor: spaceItem.PrimaryColor,
                };
            }

            return e;
        },
        loadNextPage({ entry, observer }) {
            if (this.feedNextPage && !this.loading) {
                this.getEvents();
            }
        },
        scrollToTop() {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
    },
};
